import {GlobalComponentHelper} from '@plugins-fr/globalProduct';
import 'jquery-match-height';
import {PushAds} from "@commons-fr/pushAds";
import {UserStatusService} from "@commons-fr/userStatusService";
import {productOnSalePrice} from "@commons-fr/productOnSalePrice";
import {recordUserViewTrack} from "@commons/userTracks/userTrack";
import {blogCategoryPage, blogDetailPage, blogListPage, blogSearchPage} from "@commons/userTracks/viewActionName";


$(document).ready(function() {
    const JS_VARS = JSON.parse(shops);

    const uss = new UserStatusService();
    uss.setCallback(function(result){
        let issetRecommendArea = document.querySelector('.js_recommend_area') !== null;
        if (issetRecommendArea) {
            productOnSalePrice.visibleProductList();
        }

        (new PushAds()).start();
        recordUserViewBlogTrack();
    });

    $('.js_blog_select_change').change(function(){
        var selectValue = $(this).val();
        var blogCategoryUrl = $('#blogCategoryUrl').val();
        if (selectValue != 'none' && blogCategoryUrl != undefined) {
            window.location.href = blogCategoryUrl  + '/' + selectValue;
        }
    });

    $('.js_item_name_matchheight').matchHeight();

    // 分頁功能
    if ($('.js_pagination_area').length > 0) {
        let jsVar = JSON.parse(shops);
        GlobalComponentHelper.bindProductComponent(jsVar);
    }

    function recordUserViewBlogTrack()
    {
        const path = window.location.pathname.replace(/\/(tw|en|cn)/g, '');
        let pageName = '';
        let params = {};
        if (path === '/blogs' && window.location.search.includes('search_blog_title')) {
            pageName = blogSearchPage;
            params = {
                'keyword': JS_VARS.keyword,
                'page': Number(JS_VARS.page),
            };
        } else if (path.includes('/blog/category/')) {
            pageName = blogCategoryPage;
            params = {
                'categoryId': Number(JS_VARS.categoryId),
                'page': Number(JS_VARS.page),
            };
        } else if (path.includes('/blog/')) {
            pageName = blogDetailPage;
            params = {
                'blog_id': Number(JS_VARS.blogId),
            };
        } else if (path === '/blogs') {
            pageName = blogListPage;
            params = {
                'page': Number(JS_VARS.page),
            };
        }

        if (pageName !== '') {
            recordUserViewTrack(pageName, '', params);
        }
    }
});
